import React, { useState, useEffect } from 'react';
import Marquee from 'react-fast-marquee';
import styled from 'styled-components';
import useStrapi from '../../hooks/useStrapi';

const RibbonContainer = styled.div`
  width: 100%;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  padding: 0;
  overflow: hidden;
  position: relative;
  z-index: 2;
  height: 110px;
  display: flex;
  align-items: center;
`;

const LogoItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 38px;
  min-width: 120px;
  height: 110px;
  transition: transform 0.2s, filter 0.2s, opacity 0.2s;
  filter: grayscale(0.2) brightness(0.95);
  opacity: 0.85;
  &:hover {
    transform: scale(1.12);
    filter: none;
    opacity: 1;
  }
`;

const LogoImg = styled.img`
  max-height: 90px;
  max-width: 180px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  
  /* Gestion des erreurs d'image */
  &.error {
    display: none;
  }
`;

const FadeOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 60px;
  pointer-events: none;
  z-index: 3;
`;

const FadeLeft = styled(FadeOverlay)`
  left: 0;
  background: linear-gradient(to right, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%);
`;

const FadeRight = styled(FadeOverlay)`
  right: 0;
  background: linear-gradient(to left, rgba(255,255,255,1) 60%, rgba(255,255,255,0) 100%);
`;

const RibbonWrapper = styled.div`
  position: relative;
`;

// Partenaires de secours (fallback) si Strapi n'est pas disponible
const fallbackPartners = [
  { id: 1, name: "Bes'Tof boissons", logo: "https://www.offisport.com/wp-content/uploads/2024/05/bestofboissons-200x181.jpg", type: "Privée" },
  { id: 2, name: "Centre E. Leclerc", logo: "https://www.offisport.com/wp-content/uploads/2023/10/E.-Leclerc-200x50.png", type: "Privée" },
  { id: 3, name: "Vision'TEXT", logo: "https://www.offisport.com/wp-content/uploads/2021/02/images.jpg", type: "Privée" },
  { id: 4, name: "Etablissements Berard", logo: "https://www.offisport.com/wp-content/uploads/2021/02/berard-200x99.jpg", type: "Privée" },
  { id: 5, name: "Airs de fêtes", logo: "https://www.offisport.com/wp-content/uploads/2024/10/airs-de-fetes-200x140.jpeg", type: "Privée" },
  { id: 6, name: "MobyPic'", logo: "https://www.offisport.com/wp-content/uploads/2024/04/Logo-V5-200x200.png", type: "Privée" },
  { id: 7, name: "Les entrepôts de l'Oise", logo: "https://www.offisport.com/wp-content/uploads/2024/04/Image1-200x48.png", type: "Privée" },
  { id: 8, name: "Le stadium", logo: "https://www.offisport.com/wp-content/uploads/2024/05/logo-le-stadium_05fe89d1f538dea054e149c68f1b767b-200x36.png", type: "Privée" },
  { id: 9, name: "Centre commercial de Venette", logo: "https://www.offisport.com/wp-content/uploads/2024/05/LOGO-CC-VENETTE-200x200.png", type: "Privée" },
  { id: 10, name: "Peinture compiégnoise", logo: "https://www.offisport.com/wp-content/uploads/2024/05/peinture-compiegne-200x55.png", type: "Privée" },
  { id: 11, name: "ETC", logo: "https://www.offisport.com/wp-content/uploads/2024/11/etc.jpg", type: "Privée" },
  { id: 12, name: "Veteix", logo: "https://www.offisport.com/wp-content/uploads/2024/07/veteix-200x88.png", type: "Privée" },
  { id: 13, name: "Temporis", logo: "https://www.offisport.com/wp-content/uploads/2024/09/Temporis_Logo_V02_Interim-CDI_2_vecto-200x93.jpg", type: "Privée" },
  { id: 14, name: "LSM Formations", logo: "https://www.offisport.com/wp-content/uploads/2024/09/lsm-200x92.jpeg", type: "Privée" },
  { id: 15, name: "Lusitalia", logo: "https://www.offisport.com/wp-content/uploads/2024/09/lusitalia-200x155.jpg", type: "Privée" },
  { id: 16, name: "M2D Services", logo: "https://www.offisport.com/wp-content/uploads/2024/09/m2d-200x137.png", type: "Privée" },
  { id: 17, name: "BKZ matériaux", logo: "https://www.offisport.com/wp-content/uploads/2024/11/bkz.jpg", type: "Privée" },
  { id: 18, name: "Cinéma Majestic", logo: "https://www.offisport.com/wp-content/uploads/2017/02/majestic-200x186.png", type: "Publique" },
  { id: 19, name: "Flunch", logo: "https://www.offisport.com/wp-content/uploads/2017/02/flunch-Nouveau-logo-2022-200x113.png", type: "Privée" },
  { id: 20, name: "Groupe MAB", logo: "https://www.offisport.com/wp-content/uploads/2017/02/mab-200x200.png", type: "Privée" },
  { id: 21, name: "Delabarre Formation", logo: "https://www.offisport.com/wp-content/uploads/2017/02/Delabarre1-200x200.png", type: "Privée" },
  { id: 22, name: "Park nautique Verberie", logo: "https://www.offisport.com/wp-content/uploads/2017/02/parknautic3-200x200.jpg", type: "Publique" },
  { id: 23, name: "Mon opticien", logo: "https://www.offisport.com/wp-content/uploads/2017/02/mon-opticien-200x113.jpg", type: "Privée" },
  { id: 24, name: "MENTAL WORKS", logo: "https://www.offisport.com/wp-content/uploads/2020/03/logo-MW-vertical-200x200.png", type: "Privée" }
];

// Fonction utilitaire pour créer des URLs friendly à partir de texte
const createUrlFriendlyString = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[àáâäãå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôöõ]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ýÿ]/g, 'y')
    .replace(/[ç]/g, 'c')
    .replace(/[ñ]/g, 'n')
    .replace(/[^\w\s-]/g, '') // Supprimer les caractères spéciaux
    .replace(/\s+/g, '-') // Remplacer les espaces par des tirets
    .replace(/-+/g, '-') // Remplacer les tirets multiples par un seul
    .trim('-'); // Supprimer les tirets en début et fin
};

// Fonction pour transformer les données Strapi en format utilisable
const transformStrapiPartners = (strapiData) => {
  if (!strapiData || !Array.isArray(strapiData)) return [];
  
  return strapiData.map((item, index) => {
    // Dans Strapi v5, les données peuvent être soit dans attributes soit directement dans l'item
    const data = item.attributes || item;
    
    // Gestion du logo - utiliser la même logique que les autres composants
    let logo = 'https://via.placeholder.com/200x100?text=Logo'; // Logo par défaut
    
    if (data.Logo) {
      // Support structure Strapi v5 avec .data
      const logoData = data.Logo?.data || data.Logo;
      
      if (logoData && Array.isArray(logoData) && logoData.length > 0) {
        const img = logoData[0];
        const url = img?.attributes?.url || img?.url;
        if (url) {
          logo = url.startsWith('/') ? `https://api.offisport.com${url}` : url;
        }
      } else if (logoData && !Array.isArray(logoData)) {
        const url = logoData?.attributes?.url || logoData?.url;
        if (url) {
          logo = url.startsWith('/') ? `https://api.offisport.com${url}` : url;
        }
      }
    }
    
    return {
      id: item.id || index + 1, // Utiliser l'ID Strapi ou un index
      name: data.Nom || 'Partenaire sans nom',
      logo: logo,
      type: data.Type || 'Privée', // 'Privée' ou 'Publique'
      website: data.SiteWeb || null
    };
  }).filter(partner => partner.name !== 'Partenaire sans nom'); // Filtrer les partenaires sans nom
};

/**
 * Composant de bandeau défilant des partenaires
 * @param {string} filterType - Type de partenaires à afficher : 'Privée', 'Publique', ou 'all' pour tous
 */
const PartnerRibbon = ({ filterType = 'all' }) => {
  const [partners, setPartners] = useState([]);
  const [imageErrors, setImageErrors] = useState(new Set());
  const { data: strapiPartenaires, loading, error } = useStrapi('partenaires');

  // Transformation et filtrage des partenaires
  useEffect(() => {
    if (!loading) {
      let partnersToUse = [];
      
      if (strapiPartenaires && Array.isArray(strapiPartenaires) && strapiPartenaires.length > 0) {
        partnersToUse = transformStrapiPartners(strapiPartenaires);
      } else {
        partnersToUse = fallbackPartners;
      }
      
      // Filtrage selon le type demandé
      let filteredPartners = partnersToUse;
      if (filterType !== 'all') {
        filteredPartners = partnersToUse.filter(partner => partner.type === filterType);
      }
      
      setPartners(filteredPartners);
    }
  }, [strapiPartenaires, loading, error, filterType]);

  // Affichage de chargement
  if (loading) {
    return (
      <RibbonWrapper>
        <RibbonContainer>
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            Chargement des partenaires...
          </div>
        </RibbonContainer>
      </RibbonWrapper>
    );
  }

  // Fonction pour gérer les erreurs de chargement d'images
  const handleImageError = (partnerId) => {
    setImageErrors(prev => new Set([...prev, partnerId]));
  };

  // Filtrer les partenaires avec des images valides
  const validPartners = partners.filter(partner => !imageErrors.has(partner.id));

  // Si aucun partenaire valide à afficher
  if (validPartners.length === 0) {
    return null;
  }

  // Dupliquer les partenaires pour remplir le bandeau et éviter les trous
  const duplicatePartners = () => {
    if (validPartners.length === 0) return [];
    
    // Calculer combien de fois on doit dupliquer pour avoir au moins 20 éléments
    const minElements = 20;
    const duplicationFactor = Math.ceil(minElements / validPartners.length);
    
    const duplicated = [];
    for (let i = 0; i < duplicationFactor; i++) {
      validPartners.forEach((partner, index) => {
        duplicated.push({
          ...partner,
          key: `${partner.id}-${i}-${index}` // Clé unique pour chaque duplication
        });
      });
    }
    
    return duplicated;
  };

  const displayPartners = duplicatePartners();

  return (
    <RibbonWrapper>
      <RibbonContainer>
        <Marquee 
          gradient={false} 
          speed={40} 
          pauseOnHover={true} 
          style={{ width: '100%' }}
          autoFill={true}
          loop={0}
          delay={0}
        >
          {displayPartners.map((partner, idx) => {
            // Créer l'URL friendly pour la fiche partenaire
            const urlPath = createUrlFriendlyString(partner.name);
            const partnerUrl = urlPath ? `/partenaires/${urlPath}` : `/partenaires/${partner.id}`;
            
            return (
              <LogoItem
                key={partner.key || `${partner.id}-${idx}`}
                href={partnerUrl}
                target="_blank"
                rel="noopener noreferrer"
                title={`Voir la fiche de ${partner.name}`}
              >
                <LogoImg 
                  src={partner.logo} 
                  alt={partner.name}
                  onError={() => handleImageError(partner.id)}
                  onLoad={() => {
                    // Retirer l'erreur si l'image se charge finalement
                    setImageErrors(prev => {
                      const newSet = new Set(prev);
                      newSet.delete(partner.id);
                      return newSet;
                    });
                  }}
                />
              </LogoItem>
            );
          })}
        </Marquee>
      </RibbonContainer>
      <FadeLeft />
      <FadeRight />
    </RibbonWrapper>
  );
};

export default PartnerRibbon; 